'use strict';

module.exports = '0.0.0-6ac260d';